import React from "react";

const EmpMain = () => {
  return (
    <>
      <section className="content-main">
        <div className="content-header">
          <h2 className="content-title"> Employee Dashboard </h2>
        </div>
        <div className="video-player">
        <iframe className="video-player" width="1260" height="540" src="https://www.youtube.com/embed/r1ofBMVLA_M" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </section>
    </>
  );
};

export default EmpMain;